module.exports = __webpack_public_path__ + "static/img/12.9a17db2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/12.jpg
// module id = k9Nq
// module chunks = 1